$('.header__burger').click(function(){
	$(this).toggleClass('header__burger--anim');
	$('.sidebar').toggleClass('sidebar--show');
});
$('.main-nav__dropLink').click(function () {
  $(this).find(".dropArrow").toggleClass("rotate");
  $(this).find('.main-nav__inner').slideToggle(600);
});
